<template>
  <el-dialog
    :title="$t('editStaff.editStaff')"
    :visible.sync="dialogVisible"
    width="720px"
    custom-class="edit-staff-dialog"
    center>
    <el-form :model="editStaffInfo" label-width="120px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$t('editStaff.name')" required>
            <el-input 
              v-model="editStaffInfo.username" 
              :placeholder="$t('editStaff.inputName')">
            </el-input>
          </el-form-item>
          
          <el-form-item :label="$t('editStaff.position')" required>
            <el-select 
              v-model="editStaffInfo.relCd" 
              :placeholder="$t('editStaff.selectPosition')"
              style="width:100%">
              <el-option
                v-for="(item,index) in editStaffInfo.relCds"
                :key="index"
                :label="item.name"
                :value="item.statusCd">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item :label="$t('editStaff.email')">
            <el-input 
              v-model="editStaffInfo.email" 
              :placeholder="$t('editStaff.inputEmail')">
            </el-input>
          </el-form-item>
          
          <el-form-item :label="$t('editStaff.phone')" required>
            <el-input 
              v-model="editStaffInfo.tel" 
              :placeholder="$t('editStaff.inputPhone')">
            </el-input>
          </el-form-item>
          
          <el-form-item :label="$t('editStaff.gender')" required>
            <el-select 
              v-model="editStaffInfo.sex" 
              :placeholder="$t('editStaff.selectGender')"
              style="width:100%">
              <el-option :label="$t('editStaff.male')" value="0"></el-option>
              <el-option :label="$t('editStaff.female')" value="1"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item :label="$t('editStaff.address')" required>
            <el-input 
              v-model="editStaffInfo.address" 
              :placeholder="$t('editStaff.inputAddress')">
            </el-input>
          </el-form-item>
        </el-col>
        
        <el-col :span="12" class="text-center">
          <el-image
            class="staff-photo"
            :src="editStaffInfo.faceUrl"
            :preview-src-list="editStaffInfo.faceUrl ? [editStaffInfo.faceUrl] : []"
            fit="contain">
            <div slot="error" class="image-slot">
              <img src="/img/noPhoto.jpg" style="width:100%;height:100%">
            </div>
          </el-image>
          
          <el-upload
            class="margin-top"
            action=""
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleChange">
            <el-button size="small" type="primary">{{ $t('editStaff.uploadPhoto') }}</el-button>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('editStaff.cancel') }}</el-button>
      <el-button type="primary" @click="editStaffSubmit">{{ $t('editStaff.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { modifyStaff, uploadFile } from '@/api/frame/staffApi'

export default {
  name: 'EditStaff',
  data() {
    return {
      dialogVisible: false,
      editStaffInfo: {
        userId: '',
        username: '',
        email: '',
        tel: '',
        sex: '',
        address: '',
        errorInfo: '',
        faceUrl: '',
        relCd: '',
        relCds: [],
        name: '',
        staffId: ''
      }
    }
  },
  methods: {
    open(staffInfo) {
      this.dialogVisible = true
      this.refreshEditStaffInfo(staffInfo)
      this.getRelCds()
    },
    refreshEditStaffInfo(staffInfo) {
      this.editStaffInfo = {
        ...this.editStaffInfo,
        ...staffInfo,
        username: staffInfo.name
      }
    },
    async getRelCds() {
      try {
        const {data} = await getDict('u_org_staff_rel', 'rel_cd')
        this.editStaffInfo.relCds = data
      } catch (error) {
        console.error('获取岗位字典失败:', error)
      }
    },
    handleChange(file) {
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error(this.$t('editStaff.imageSizeLimit'))
        return false
      }
      this.uploadImage(file.raw)
    },
    async uploadImage(file) {
      const formData = new FormData()
      formData.append('uploadFile', file)
      
      try {
        const res = await uploadFile(formData)
        this.editStaffInfo.faceUrl = res.data.url
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    validateForm() {
      if (!this.editStaffInfo.username || this.editStaffInfo.username.length < 2 || this.editStaffInfo.username.length > 10) {
        this.$message.error(this.$t('editStaff.nameValidate'))
        return false
      }
      if (!this.editStaffInfo.tel) {
        this.$message.error(this.$t('editStaff.phoneRequired'))
        return false
      }
      if (!this.editStaffInfo.sex) {
        this.$message.error(this.$t('editStaff.genderRequired'))
        return false
      }
      if (!this.editStaffInfo.address || this.editStaffInfo.address.length > 200) {
        this.$message.error(this.$t('editStaff.addressValidate'))
        return false
      }
      return true
    },
    async editStaffSubmit() {
      if (!this.validateForm()) return
      
      this.editStaffInfo.name = this.editStaffInfo.username
      this.editStaffInfo.staffId = this.editStaffInfo.userId
      
      try {
        const res = await modifyStaff(this.editStaffInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('editStaff.editSuccess'))
          this.$emit('success')
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
.margin-top {
  margin-top: 20px;
}

::v-deep .edit-staff-dialog {
  max-width: calc(100vw - 40px);
}

.staff-photo {
  width: 200px;
  height: clamp(200px, 30vh, 360px);
}

@media (max-width: 768px) {
  ::v-deep .edit-staff-dialog {
    width: calc(100vw - 40px) !important;
  }
  .staff-photo {
    height: 220px;
  }
}
</style>